import { render, staticRenderFns } from "./VxCellBadges.vue?vue&type=template&id=28d5f666&scoped=true&"
import script from "./VxCellBadges.vue?vue&type=script&lang=js&"
export * from "./VxCellBadges.vue?vue&type=script&lang=js&"
import style0 from "./VxCellBadges.vue?vue&type=style&index=0&id=28d5f666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d5f666",
  null
  
)

export default component.exports